import patientModel from './patient-model'

const storeModel = {
  user: patientModel
}

export default storeModel
